module.exports = __webpack_public_path__ + "img/pc-graphic.914ec362.svg";